function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCgjta1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2339px",
    height: "1654px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 779.167,-0.5 1558.83,-0.5 2338.5,-0.5C 2338.5,550.833 2338.5,1102.17 2338.5,1653.5C 1558.83,1653.5 779.167,1653.5 -0.5,1653.5C -0.5,1102.17 -0.5,550.833 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1654ba",
    d: "M 487.5,693.5 C 489.604,693.201 491.604,693.534 493.5,694.5C 476.076,709.755 457.909,724.089 439,737.5C 430.916,725.001 423.083,712.334 415.5,699.5C 417.078,698.702 418.744,698.202 420.5,698C 443.028,697.06 465.361,695.56 487.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b557",
    d: "M 1573.5,694.5 C 1575.83,694.5 1578.17,694.5 1580.5,694.5C 1580.36,699.062 1582.36,702.229 1586.5,704C 1649.83,704.667 1713.17,704.667 1776.5,704C 1780.91,702.338 1783.24,699.171 1783.5,694.5C 1785.83,694.5 1788.17,694.5 1790.5,694.5C 1790.5,713.5 1790.5,732.5 1790.5,751.5C 1787.83,751.5 1785.17,751.5 1782.5,751.5C 1783.05,746.882 1781.05,744.049 1776.5,743C 1752.84,742.5 1729.17,742.333 1705.5,742.5C 1705.33,798.168 1705.5,853.834 1706,909.5C 1708.13,911.377 1710.63,912.377 1713.5,912.5C 1713.5,914.833 1713.5,917.167 1713.5,919.5C 1692.83,919.5 1672.17,919.5 1651.5,919.5C 1651.19,917.076 1651.53,914.743 1652.5,912.5C 1655.13,911.699 1656.97,910.033 1658,907.5C 1658.5,852.501 1658.67,797.501 1658.5,742.5C 1634.16,742.333 1609.83,742.5 1585.5,743C 1581.91,744.674 1580.24,747.507 1580.5,751.5C 1578.17,751.5 1575.83,751.5 1573.5,751.5C 1573.5,732.5 1573.5,713.5 1573.5,694.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1152b9",
    d: "M 508.5,696.5 C 513.05,695.884 517.05,697.051 520.5,700C 535.298,713.804 550.965,726.471 567.5,738C 529.833,738.667 492.167,738.667 454.5,738C 472.4,723.92 490.4,710.087 508.5,696.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1654ba",
    d: "M 590.5,698.5 C 595.5,699.167 600.5,699.833 605.5,700.5C 598.839,713.158 591.173,725.158 582.5,736.5C 565.141,724.153 548.141,711.319 531.5,698C 551.166,697.811 570.832,697.978 590.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86a7db",
    d: "M 590.5,698.5 C 595.875,698.172 601.208,698.505 606.5,699.5C 606.376,700.107 606.043,700.44 605.5,700.5C 600.5,699.833 595.5,699.167 590.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a55ba",
    d: "M 389.5,700.5 C 394.959,700.103 400.292,700.603 405.5,702C 413.126,712.746 420.126,723.912 426.5,735.5C 398.169,730.417 370.169,723.417 342.5,714.5C 341.167,713.833 341.167,713.167 342.5,712.5C 358.183,707.997 373.85,703.997 389.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1754ba",
    d: "M 617.5,700.5 C 639.089,701.361 659.756,705.861 679.5,714C 651.445,722.222 623.278,730.056 595,737.5C 601.752,724.87 609.252,712.536 617.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b556",
    d: "M 896.5,702.5 C 936.331,700.667 974.664,707.333 1011.5,722.5C 1014.08,721.589 1016.08,719.923 1017.5,717.5C 1019.36,719.192 1021.36,720.692 1023.5,722C 1013.03,738.635 1002.36,755.135 991.5,771.5C 990.186,770.687 989.019,769.687 988,768.5C 987.234,761.066 983.4,755.899 976.5,753C 948.965,738.577 919.965,734.244 889.5,740C 844.946,751.952 825.446,780.785 831,826.5C 837.464,852.905 853.631,870.405 879.5,879C 906.313,886.702 932.979,886.035 959.5,877C 972.43,873.381 983.93,867.214 994,858.5C 996.462,855.068 996.962,851.401 995.5,847.5C 997.008,844.582 999.175,843.916 1002,845.5C 1010.33,858.833 1018.67,872.167 1027,885.5C 1027.51,886.996 1027.01,888.163 1025.5,889C 1022.83,889.333 1020.17,889.667 1017.5,890C 990.767,905.578 962.1,915.578 931.5,920C 896.817,923.762 864.15,917.429 833.5,901C 796.808,876.775 780.642,842.608 785,798.5C 789.429,765.748 805.595,740.582 833.5,723C 853.132,711.681 874.132,704.848 896.5,702.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b557",
    d: "M 1183.5,702.5 C 1221.51,700.738 1258.51,705.905 1294.5,718C 1296.83,718.667 1299.17,718.667 1301.5,718C 1303.39,716.596 1305.39,715.43 1307.5,714.5C 1309.27,715.091 1310.93,715.924 1312.5,717C 1304.55,735.06 1296.22,752.893 1287.5,770.5C 1285.29,769.894 1283.12,769.227 1281,768.5C 1280.67,765.167 1280.33,761.833 1280,758.5C 1273.77,751.948 1266.27,747.448 1257.5,745C 1234.61,738.481 1211.28,736.148 1187.5,738C 1136.23,748.333 1114.4,779.5 1122,831.5C 1127.54,856.044 1142.04,872.877 1165.5,882C 1173.33,884.639 1181.33,886.639 1189.5,888C 1219.33,890.123 1248.33,886.289 1276.5,876.5C 1276.5,864.833 1276.5,853.167 1276.5,841.5C 1256.83,841.333 1237.16,841.5 1217.5,842C 1213.21,845.093 1211.54,849.26 1212.5,854.5C 1209.83,854.5 1207.17,854.5 1204.5,854.5C 1204.5,836.833 1204.5,819.167 1204.5,801.5C 1207.17,801.5 1209.83,801.5 1212.5,801.5C 1211.55,806.772 1213.55,810.272 1218.5,812C 1254.5,812.5 1290.5,812.667 1326.5,812.5C 1326.66,814.857 1326.5,817.19 1326,819.5C 1323.93,820.264 1321.76,820.764 1319.5,821C 1317.51,821.574 1316.01,822.741 1315,824.5C 1314.33,842.833 1314.33,861.167 1315,879.5C 1316.92,881.209 1319.08,882.543 1321.5,883.5C 1322.65,885.765 1322.81,888.098 1322,890.5C 1296.7,907.268 1268.87,917.101 1238.5,920C 1221.17,920.667 1203.83,920.667 1186.5,920C 1153.07,919.088 1124.57,906.921 1101,883.5C 1080.41,858.179 1072.08,829.179 1076,796.5C 1085.11,747.056 1114.28,716.89 1163.5,706C 1170.34,704.996 1177,703.829 1183.5,702.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b557",
    d: "M 1457.5,704.5 C 1483.5,704.5 1509.5,704.5 1535.5,704.5C 1535.5,707.167 1535.5,709.833 1535.5,712.5C 1528.2,711.565 1522.7,714.232 1519,720.5C 1518.67,769.5 1518.33,818.5 1518,867.5C 1514.4,888.84 1502.57,903.674 1482.5,912C 1464.91,918.304 1446.75,921.137 1428,920.5C 1406.89,920.532 1386.39,917.032 1366.5,910C 1360.73,908.462 1355.73,909.629 1351.5,913.5C 1349.08,912.48 1347.41,910.814 1346.5,908.5C 1352.88,892.072 1360.05,876.072 1368,860.5C 1369.87,861.068 1371.7,861.735 1373.5,862.5C 1375.77,869.602 1380.1,875.102 1386.5,879C 1406.4,889.789 1427.4,892.456 1449.5,887C 1460.48,884.683 1467.65,878.183 1471,867.5C 1471.67,818.167 1471.67,768.833 1471,719.5C 1467.71,714.939 1463.21,712.606 1457.5,712.5C 1457.5,709.833 1457.5,707.167 1457.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3b556",
    d: "M 1903.5,704.5 C 1926.5,704.5 1949.5,704.5 1972.5,704.5C 1972.5,707.167 1972.5,709.833 1972.5,712.5C 1964.93,713.665 1962.43,717.998 1965,725.5C 1995.68,785.531 2026.35,845.531 2057,905.5C 2060.33,908.333 2063.99,910.666 2068,912.5C 2068.5,914.81 2068.66,917.143 2068.5,919.5C 2044.5,919.5 2020.5,919.5 1996.5,919.5C 1996.34,917.143 1996.5,914.81 1997,912.5C 2002.23,910.674 2003.89,907.007 2002,901.5C 1996.31,889.953 1990.48,878.453 1984.5,867C 1951.17,866.333 1917.83,866.333 1884.5,867C 1877.93,879.3 1871.77,891.8 1866,904.5C 1865.12,910.128 1867.62,912.794 1873.5,912.5C 1873.5,914.833 1873.5,917.167 1873.5,919.5C 1854.17,919.5 1834.83,919.5 1815.5,919.5C 1815.19,917.076 1815.53,914.743 1816.5,912.5C 1818.92,911.543 1821.08,910.209 1823,908.5C 1826.33,902.5 1829.67,896.5 1833,890.5C 1859.14,835.081 1885.47,779.748 1912,724.5C 1912.67,721.833 1912.67,719.167 1912,716.5C 1909.5,714.583 1906.83,712.916 1904,711.5C 1903.5,709.19 1903.34,706.857 1903.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 336.5,723.5 C 365.536,731.009 394.536,738.676 423.5,746.5C 404.524,760.976 385.69,775.642 367,790.5C 356.29,768.414 346.124,746.08 336.5,723.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1453b9",
    d: "M 681.5,723.5 C 682.873,723.343 684.207,723.51 685.5,724C 675.629,746.241 665.629,768.408 655.5,790.5C 635.986,775.909 616.653,761.076 597.5,746C 625.725,738.78 653.725,731.28 681.5,723.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1754ba",
    d: "M 325.5,725.5 C 335.725,746.956 345.725,768.623 355.5,790.5C 355,790.833 354.5,791.167 354,791.5C 338.082,786.084 322.415,780.084 307,773.5C 309.512,756.134 315.679,740.134 325.5,725.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1654ba",
    d: "M 694.5,726.5 C 702.512,741.852 709.179,757.852 714.5,774.5C 699.052,780.038 683.718,785.872 668.5,792C 667.365,792.749 666.365,792.583 665.5,791.5C 675.368,769.887 685.034,748.221 694.5,726.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1253b9",
    d: "M 455.5,748.5 C 492.499,749 529.499,749.5 566.5,750C 548.452,760.691 530.118,770.857 511.5,780.5C 494.218,771.859 477.218,762.692 460.5,753C 458.308,751.933 456.642,750.433 455.5,748.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554b9",
    d: "M 444.5,783.5 C 439.706,784.097 435.373,783.43 431.5,781.5C 433.841,773.14 436.341,764.807 439,756.5C 439.368,755.09 440.201,754.09 441.5,753.5C 458.98,761.735 475.647,771.235 491.5,782C 475.841,782.805 460.175,783.305 444.5,783.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1453b9",
    d: "M 589.5,780.5 C 580.023,781.832 570.19,782.499 560,782.5C 549.994,782.5 540.161,782.166 530.5,781.5C 546.557,771.137 563.223,761.803 580.5,753.5C 584.469,762.075 587.469,771.075 589.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1855ba",
    d: "M 427.5,756.5 C 428.598,757.601 428.765,758.934 428,760.5C 426.004,766.489 424.004,772.489 422,778.5C 421.208,780.587 420.041,782.421 418.5,784C 414.679,785.832 410.679,787.166 406.5,788C 397.827,789.674 389.161,791.007 380.5,792C 396.351,780.303 412.017,768.47 427.5,756.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b56ba",
    d: "M 593.5,756.5 C 609.555,767.708 625.222,779.542 640.5,792C 628.26,790.96 616.26,788.626 604.5,785C 599.775,776.003 596.108,766.503 593.5,756.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 1968.5,834.5 C 1945.01,835.498 1921.34,835.831 1897.5,835.5C 1909.97,810.553 1922.47,785.553 1935,760.5C 1946.46,785.031 1957.62,809.697 1968.5,834.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#618dd0",
    d: "M 589.5,780.5 C 590.404,781.209 590.737,782.209 590.5,783.5C 570.156,783.833 549.822,783.5 529.5,782.5C 529.624,781.893 529.957,781.56 530.5,781.5C 540.161,782.166 549.994,782.5 560,782.5C 570.19,782.499 580.023,781.832 589.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7bfe5",
    d: "M 431.5,781.5 C 435.373,783.43 439.706,784.097 444.5,783.5C 440.03,784.486 435.363,784.819 430.5,784.5C 430.263,783.209 430.596,782.209 431.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554b9",
    d: "M 299.5,845.5 C 298.518,842.038 298.185,838.371 298.5,834.5C 300.303,818.136 302.303,801.802 304.5,785.5C 307.894,784.777 311.228,785.277 314.5,787C 328.437,791.755 342.104,797.088 355.5,803C 336.673,816.999 318.006,831.166 299.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1654ba",
    d: "M 713.5,784.5 C 715.451,784.227 716.951,784.893 718,786.5C 719.118,804.585 720.952,822.585 723.5,840.5C 723.167,841.833 722.833,843.167 722.5,844.5C 703.948,830.731 685.615,816.731 667.5,802.5C 682.662,795.894 697.996,789.894 713.5,784.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1052b9",
    d: "M 459.5,791.5 C 504.537,791.335 549.537,792.335 594.5,794.5C 596.975,836.388 596.975,878.221 594.5,920C 544.172,921.327 493.839,921.66 443.5,921C 438.582,920.805 433.749,920.305 429,919.5C 428.333,877.5 428.333,835.5 429,793.5C 439.265,792.844 449.432,792.178 459.5,791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554ba",
    d: "M 416.5,836.5 C 415.833,838.5 415.167,840.5 414.5,842.5C 401.231,831.065 388.731,818.731 377,805.5C 376.517,804.552 376.351,803.552 376.5,802.5C 390.087,800.021 403.753,798.021 417.5,796.5C 417.046,809.83 416.712,823.163 416.5,836.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554b9",
    d: "M 605.5,795.5 C 618.642,798.127 631.642,801.127 644.5,804.5C 631.816,818.017 619.316,831.683 607,845.5C 604.953,828.819 604.453,812.152 605.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1153b9",
    d: "M 359.5,811.5 C 359.831,841.671 359.498,871.671 358.5,901.5C 339.328,886.499 319.994,871.666 300.5,857C 319.776,841.211 339.443,826.045 359.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1253b9",
    d: "M 663.5,812.5 C 678.673,824.168 694.007,835.668 709.5,847C 713.512,849.679 716.846,853.012 719.5,857C 701.63,872.286 683.296,887.12 664.5,901.5C 663.29,878.515 662.623,855.515 662.5,832.5C 662.176,825.646 662.509,818.979 663.5,812.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554ba",
    d: "M 370.5,813.5 C 385.296,827.132 399.296,841.632 412.5,857C 398.786,871.577 384.953,886.077 371,900.5C 370.5,871.502 370.333,842.502 370.5,813.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1854ba",
    d: "M 650.5,813.5 C 651.167,819.167 651.833,824.833 652.5,830.5C 653.361,853.829 653.528,877.162 653,900.5C 637.821,886.654 623.321,872.154 609.5,857C 622.627,842.039 636.293,827.539 650.5,813.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6cae9",
    d: "M 663.5,812.5 C 662.509,818.979 662.176,825.646 662.5,832.5C 661.181,825.656 661.181,818.656 662.5,811.5C 663.107,811.624 663.44,811.957 663.5,812.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7398d4",
    d: "M 650.5,813.5 C 650.56,812.957 650.893,812.624 651.5,812.5C 652.496,818.463 652.829,824.463 652.5,830.5C 651.833,824.833 651.167,819.167 650.5,813.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efe5c4",
    d: "M 1968.5,834.5 C 1969.04,834.56 1969.38,834.893 1969.5,835.5C 1957.33,835.833 1945.17,836.167 1933,836.5C 1920.43,836.51 1908.59,836.177 1897.5,835.5C 1921.34,835.831 1945.01,835.498 1968.5,834.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4bee5",
    d: "M 298.5,834.5 C 298.185,838.371 298.518,842.038 299.5,845.5C 299.44,846.043 299.107,846.376 298.5,846.5C 297.191,842.351 297.191,838.351 298.5,834.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c9fd7",
    d: "M 416.5,836.5 C 416.808,838.924 416.474,841.257 415.5,843.5C 414.893,843.376 414.56,843.043 414.5,842.5C 415.167,840.5 415.833,838.5 416.5,836.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e97d5",
    d: "M 359.5,811.5 C 360.83,841.669 360.83,872.003 359.5,902.5C 358.893,902.376 358.56,902.043 358.5,901.5C 359.498,871.671 359.831,841.671 359.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 298.5,868.5 C 317.555,882.042 336.222,896.209 354.5,911C 338.166,918.333 321.499,924.833 304.5,930.5C 301.677,909.915 299.677,889.248 298.5,868.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1554b9",
    d: "M 606.5,869.5 C 620.177,882.177 633.177,895.51 645.5,909.5C 631.866,912.627 618.2,915.627 604.5,918.5C 604.952,902.146 605.619,885.813 606.5,869.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1453b9",
    d: "M 720.5,869.5 C 721.552,869.351 722.552,869.517 723.5,870C 721.379,889.819 719.046,909.653 716.5,929.5C 699.77,924.289 683.437,918.289 667.5,911.5C 685.186,897.476 702.852,883.476 720.5,869.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1855ba",
    d: "M 413.5,869.5 C 415.377,876.436 416.544,883.77 417,891.5C 417.5,900.16 417.666,908.827 417.5,917.5C 403.313,915.969 389.313,913.469 375.5,910C 387.637,896.862 400.137,884.029 413,871.5C 413.464,870.906 413.631,870.239 413.5,869.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1d56bb",
    d: "M 382.5,921.5 C 394.195,923.783 405.862,926.283 417.5,929C 419.378,930.543 420.878,932.376 422,934.5C 423.909,940.632 425.742,946.799 427.5,953C 427.167,953.5 426.833,954 426.5,954.5C 411.183,944.158 396.516,933.158 382.5,921.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1b56bb",
    d: "M 631.5,922.5 C 633.857,922.337 636.19,922.503 638.5,923C 623.935,934.531 609.102,945.698 594,956.5C 596.131,949.659 598.131,942.659 600,935.5C 601.5,931.333 604.333,928.5 608.5,927C 616.433,926.179 624.1,924.679 631.5,922.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 665.5,922.5 C 682.15,927.216 698.316,933.216 714,940.5C 711.57,955.46 706.903,969.793 700,983.5C 698.907,985.349 697.574,987.016 696,988.5C 685.565,966.629 675.398,944.629 665.5,922.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1454b9",
    d: "M 350.5,923.5 C 355,923.219 355.833,924.886 353,928.5C 344,948.5 335,968.5 326,988.5C 316.315,973.769 309.982,957.769 307,940.5C 321.543,934.712 336.043,929.046 350.5,923.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 365.5,923.5 C 366.922,923.709 368.255,924.209 369.5,925C 388.167,939 406.833,953 425.5,967C 396.093,974.852 366.76,983.019 337.5,991.5C 337.167,991 336.833,990.5 336.5,990C 346.591,967.987 356.258,945.821 365.5,923.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1453b9",
    d: "M 654.5,923.5 C 665.448,944.896 675.448,966.729 684.5,989C 655.074,982.477 625.741,975.311 596.5,967.5C 615.863,952.824 635.197,938.158 654.5,923.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8babdd",
    d: "M 458.5,930.5 C 449.105,929.862 440.105,930.529 431.5,932.5C 430.596,931.791 430.263,930.791 430.5,929.5C 440.015,929.173 449.348,929.506 458.5,930.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91afde",
    d: "M 566.5,930.5 C 574.676,929.179 583.009,929.179 591.5,930.5C 591.376,931.107 591.043,931.44 590.5,931.5C 582.684,930.508 574.684,930.174 566.5,930.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1253b9",
    d: "M 458.5,930.5 C 469.182,931.084 479.848,931.918 490.5,933C 474.462,943.019 458.129,952.519 441.5,961.5C 437.403,952.212 434.069,942.545 431.5,932.5C 440.105,930.529 449.105,929.862 458.5,930.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 566.5,930.5 C 574.684,930.174 582.684,930.508 590.5,931.5C 587.578,940.436 584.744,949.436 582,958.5C 581.439,959.022 580.772,959.355 580,959.5C 562.943,950.722 546.109,941.555 529.5,932C 541.831,931.379 554.165,930.879 566.5,930.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1253b9",
    d: "M 565.5,964.5 C 528.996,964.832 492.663,964.498 456.5,963.5C 474.417,953.042 492.75,943.375 511.5,934.5C 530.121,943.475 548.121,953.475 565.5,964.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6d96d5",
    d: "M 456.5,963.5 C 492.663,964.498 528.996,964.832 565.5,964.5C 528.669,965.664 491.669,965.831 454.5,965C 455.044,964.283 455.711,963.783 456.5,963.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1153b9",
    d: "M 454.5,976.5 C 491.669,975.17 529.002,975.17 566.5,976.5C 549.69,989.476 533.023,1002.64 516.5,1016C 514.61,1017.11 512.61,1017.95 510.5,1018.5C 491.557,1004.89 472.891,990.894 454.5,976.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1654ba",
    d: "M 438.5,976.5 C 457.162,989.838 475.495,1003.67 493.5,1018C 477.833,1018.67 462.167,1018.67 446.5,1018C 436.75,1017.71 427.083,1016.71 417.5,1015C 417.043,1014.59 416.709,1014.09 416.5,1013.5C 423.593,1000.97 430.926,988.64 438.5,976.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1353b9",
    d: "M 579.5,977.5 C 580.552,977.351 581.552,977.517 582.5,978C 591.288,989.067 598.954,1000.9 605.5,1013.5C 579.551,1016.33 553.551,1018.16 527.5,1019C 542.882,1006.62 558.549,994.617 574.5,983C 576.373,981.296 578.04,979.463 579.5,977.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a55ba",
    d: "M 423.5,977.5 C 424.552,977.351 425.552,977.517 426.5,978C 419.751,989.501 412.751,1000.83 405.5,1012C 403.5,1012.67 401.5,1012.67 399.5,1012C 380.374,1008.09 361.374,1004.09 342.5,1000C 369.478,992.008 396.478,984.508 423.5,977.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1453b9",
    d: "M 595.5,977.5 C 623.233,985.183 650.9,993.016 678.5,1001C 658.843,1008.46 638.509,1012.46 617.5,1013C 609.518,1001.53 602.185,989.697 595.5,977.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 1253.5,998.5 C 1253.5,1006.5 1253.5,1014.5 1253.5,1022.5C 1252.17,1022.5 1250.83,1022.5 1249.5,1022.5C 1249.67,1014.83 1249.5,1007.16 1249,999.5C 1247.97,997.484 1246.31,996.484 1244,996.5C 1240.76,997.286 1237.76,998.619 1235,1000.5C 1234.5,1007.83 1234.33,1015.16 1234.5,1022.5C 1233.17,1022.5 1231.83,1022.5 1230.5,1022.5C 1230.5,1008.5 1230.5,994.5 1230.5,980.5C 1231.83,980.5 1233.17,980.5 1234.5,980.5C 1234.17,985.875 1234.51,991.208 1235.5,996.5C 1239.68,993.234 1244.35,992.067 1249.5,993C 1251.46,994.451 1252.8,996.284 1253.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#484848",
    d: "M 1607.5,980.5 C 1608.83,980.5 1610.17,980.5 1611.5,980.5C 1611.5,994.833 1611.5,1009.17 1611.5,1023.5C 1602.71,1025.07 1595.21,1022.73 1589,1016.5C 1584.71,1006.58 1587.54,999.414 1597.5,995C 1600.76,993.957 1604.09,993.457 1607.5,993.5C 1607.5,989.167 1607.5,984.833 1607.5,980.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a4a",
    d: "M 1725.5,1022.5 C 1725.5,1013.83 1725.5,1005.17 1725.5,996.5C 1723.5,996.5 1721.5,996.5 1719.5,996.5C 1719.5,995.5 1719.5,994.5 1719.5,993.5C 1721.17,993.5 1722.83,993.5 1724.5,993.5C 1724.86,983.82 1729.86,979.486 1739.5,980.5C 1739.5,981.833 1739.5,983.167 1739.5,984.5C 1732.33,983.339 1729,986.339 1729.5,993.5C 1732.83,993.5 1736.17,993.5 1739.5,993.5C 1739.5,994.5 1739.5,995.5 1739.5,996.5C 1736.17,996.5 1732.83,996.5 1729.5,996.5C 1729.5,1005.17 1729.5,1013.83 1729.5,1022.5C 1728.17,1022.5 1726.83,1022.5 1725.5,1022.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M 1989.5,980.5 C 1990.83,980.5 1992.17,980.5 1993.5,980.5C 1993.5,994.5 1993.5,1008.5 1993.5,1022.5C 1992.17,1022.5 1990.83,1022.5 1989.5,1022.5C 1989.5,1008.5 1989.5,994.5 1989.5,980.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b4b4b",
    d: "M 881.5,982.5 C 883.167,982.5 884.833,982.5 886.5,982.5C 886.5,984.167 886.5,985.833 886.5,987.5C 884.833,987.5 883.167,987.5 881.5,987.5C 881.5,985.833 881.5,984.167 881.5,982.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#505050",
    d: "M 1081.5,982.5 C 1083.17,982.5 1084.83,982.5 1086.5,982.5C 1086.5,984.167 1086.5,985.833 1086.5,987.5C 1084.83,987.5 1083.17,987.5 1081.5,987.5C 1081.5,985.833 1081.5,984.167 1081.5,982.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 1778.5,983.5 C 1782.5,983.5 1786.5,983.5 1790.5,983.5C 1790.5,984.833 1790.5,986.167 1790.5,987.5C 1786.82,987.335 1783.15,987.501 1779.5,988C 1774.3,990.138 1773.3,993.471 1776.5,998C 1781.25,1000.46 1785.75,1003.29 1790,1006.5C 1793.2,1015.53 1790.03,1021.03 1780.5,1023C 1776.51,1023.5 1772.51,1023.67 1768.5,1023.5C 1768.5,1022.17 1768.5,1020.83 1768.5,1019.5C 1772.51,1019.67 1776.51,1019.5 1780.5,1019C 1785.75,1017.76 1787.58,1014.6 1786,1009.5C 1781.92,1006.87 1777.75,1004.37 1773.5,1002C 1769.59,998.431 1768.75,994.264 1771,989.5C 1773.13,986.847 1775.63,984.847 1778.5,983.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#484848",
    d: "M 1834.5,982.5 C 1836.17,982.5 1837.83,982.5 1839.5,982.5C 1839.5,984.167 1839.5,985.833 1839.5,987.5C 1837.83,987.5 1836.17,987.5 1834.5,987.5C 1834.5,985.833 1834.5,984.167 1834.5,982.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 855.5,984.5 C 865.105,985.603 869.272,990.937 868,1000.5C 864.097,1008.61 857.597,1011.94 848.5,1010.5C 848.5,1014.5 848.5,1018.5 848.5,1022.5C 847.167,1022.5 845.833,1022.5 844.5,1022.5C 844.5,1009.83 844.5,997.167 844.5,984.5C 848.167,984.5 851.833,984.5 855.5,984.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 1351.5,1003.5 C 1352.83,1003.5 1354.17,1003.5 1355.5,1003.5C 1355.5,1009.83 1355.5,1016.17 1355.5,1022.5C 1351.5,1022.5 1347.5,1022.5 1343.5,1022.5C 1328.44,1020.04 1322.6,1011.38 1326,996.5C 1332.73,986.516 1342.23,982.183 1354.5,983.5C 1354.5,984.833 1354.5,986.167 1354.5,987.5C 1345.68,986.623 1338.18,989.29 1332,995.5C 1327.7,1003.57 1329.2,1010.4 1336.5,1016C 1341.25,1018.27 1346.25,1019.44 1351.5,1019.5C 1351.5,1014.17 1351.5,1008.83 1351.5,1003.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#424242",
    d: "M 1495.5,1022.5 C 1495.5,1010.83 1495.5,999.167 1495.5,987.5C 1490.83,987.5 1486.17,987.5 1481.5,987.5C 1481.5,986.5 1481.5,985.5 1481.5,984.5C 1492.17,984.5 1502.83,984.5 1513.5,984.5C 1513.5,985.5 1513.5,986.5 1513.5,987.5C 1508.83,987.5 1504.17,987.5 1499.5,987.5C 1499.5,999.167 1499.5,1010.83 1499.5,1022.5C 1498.17,1022.5 1496.83,1022.5 1495.5,1022.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 1881.5,984.5 C 1881.5,995.833 1881.5,1007.17 1881.5,1018.5C 1887.83,1018.5 1894.17,1018.5 1900.5,1018.5C 1900.5,1019.83 1900.5,1021.17 1900.5,1022.5C 1892.83,1022.5 1885.17,1022.5 1877.5,1022.5C 1877.5,1009.83 1877.5,997.167 1877.5,984.5C 1878.83,984.5 1880.17,984.5 1881.5,984.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454545",
    d: "M 1217.5,996.5 C 1213.83,996.5 1210.17,996.5 1206.5,996.5C 1206.18,1002.36 1206.51,1008.02 1207.5,1013.5C 1208.51,1018.19 1211.51,1020.19 1216.5,1019.5C 1216.5,1020.5 1216.5,1021.5 1216.5,1022.5C 1210.37,1023.85 1205.87,1021.85 1203,1016.5C 1202.5,1009.84 1202.33,1003.17 1202.5,996.5C 1200.83,996.5 1199.17,996.5 1197.5,996.5C 1197.5,995.5 1197.5,994.5 1197.5,993.5C 1199.17,993.5 1200.83,993.5 1202.5,993.5C 1202.5,991.167 1202.5,988.833 1202.5,986.5C 1203.83,986.5 1205.17,986.5 1206.5,986.5C 1206.5,988.833 1206.5,991.167 1206.5,993.5C 1210.17,993.5 1213.83,993.5 1217.5,993.5C 1217.5,994.5 1217.5,995.5 1217.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 848.5,987.5 C 856.585,986.21 861.585,989.377 863.5,997C 861.891,1005.15 856.891,1008.32 848.5,1006.5C 848.5,1000.17 848.5,993.833 848.5,987.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 855.5,984.5 C 851.833,984.5 848.167,984.5 844.5,984.5C 844.5,997.167 844.5,1009.83 844.5,1022.5C 845.833,1022.5 847.167,1022.5 848.5,1022.5C 847.081,1023.45 845.415,1023.78 843.5,1023.5C 843.5,1010.17 843.5,996.833 843.5,983.5C 847.702,983.183 851.702,983.517 855.5,984.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454545",
    d: "M 882.5,993.5 C 883.833,993.5 885.167,993.5 886.5,993.5C 886.5,1003.17 886.5,1012.83 886.5,1022.5C 885.167,1022.5 883.833,1022.5 882.5,1022.5C 882.5,1012.83 882.5,1003.17 882.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 910.5,992.5 C 925.771,993.021 931.271,1000.69 927,1015.5C 921.016,1024.24 913.516,1025.74 904.5,1020C 897.533,1008.69 899.533,999.528 910.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 965.5,998.5 C 965.5,1006.5 965.5,1014.5 965.5,1022.5C 964.167,1022.5 962.833,1022.5 961.5,1022.5C 961.666,1014.83 961.5,1007.16 961,999.5C 959.972,997.484 958.305,996.484 956,996.5C 952.761,997.286 949.761,998.619 947,1000.5C 946.5,1007.83 946.334,1015.16 946.5,1022.5C 945.167,1022.5 943.833,1022.5 942.5,1022.5C 942.5,1012.83 942.5,1003.17 942.5,993.5C 943.833,993.5 945.167,993.5 946.5,993.5C 946.281,994.675 946.614,995.675 947.5,996.5C 951.378,993.556 955.711,992.39 960.5,993C 963.079,994.076 964.746,995.909 965.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 1004.5,1006.5 C 997.5,1006.5 990.5,1006.5 983.5,1006.5C 983.232,1008.1 983.566,1009.43 984.5,1010.5C 985.687,1015.19 988.687,1018.02 993.5,1019C 996.482,1019.5 999.482,1019.66 1002.5,1019.5C 1002.5,1020.5 1002.5,1021.5 1002.5,1022.5C 986.032,1024.86 978.532,1017.86 980,1001.5C 987.729,989.861 995.729,989.528 1004,1000.5C 1004.5,1002.47 1004.66,1004.47 1004.5,1006.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4e4e",
    d: "M 1028.5,1018.5 C 1031.29,1019.48 1034.29,1019.81 1037.5,1019.5C 1037.5,1020.5 1037.5,1021.5 1037.5,1022.5C 1021.46,1024.29 1014.29,1017.29 1016,1001.5C 1019.22,994.306 1024.72,991.473 1032.5,993C 1038.16,996.162 1040.83,1001 1040.5,1007.5C 1033.5,1007.5 1026.5,1007.5 1019.5,1007.5C 1019.92,1013.26 1022.92,1016.93 1028.5,1018.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 1058.5,1001.5 C 1057.51,1008.31 1057.18,1015.31 1057.5,1022.5C 1056.17,1022.5 1054.83,1022.5 1053.5,1022.5C 1053.5,1012.83 1053.5,1003.17 1053.5,993.5C 1054.83,993.5 1056.17,993.5 1057.5,993.5C 1057.24,994.978 1057.57,996.311 1058.5,997.5C 1062.09,994.902 1065.93,993.902 1070,994.5C 1070.48,995.448 1070.65,996.448 1070.5,997.5C 1066.15,997.837 1062.15,999.171 1058.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414241",
    d: "M 1082.5,993.5 C 1083.83,993.5 1085.17,993.5 1086.5,993.5C 1086.5,1003.17 1086.5,1012.83 1086.5,1022.5C 1085.17,1022.5 1083.83,1022.5 1082.5,1022.5C 1082.5,1012.83 1082.5,1003.17 1082.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 1126.5,998.5 C 1126.5,1006.5 1126.5,1014.5 1126.5,1022.5C 1125.17,1022.5 1123.83,1022.5 1122.5,1022.5C 1122.67,1014.83 1122.5,1007.16 1122,999.5C 1120.82,997.643 1119.15,996.643 1117,996.5C 1113.76,997.286 1110.76,998.619 1108,1000.5C 1107.5,1007.83 1107.33,1015.16 1107.5,1022.5C 1106.17,1022.5 1104.83,1022.5 1103.5,1022.5C 1103.5,1012.83 1103.5,1003.17 1103.5,993.5C 1104.83,993.5 1106.17,993.5 1107.5,993.5C 1107.28,994.675 1107.61,995.675 1108.5,996.5C 1112.41,993.534 1116.74,992.367 1121.5,993C 1124.08,994.076 1125.75,995.909 1126.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4f4f",
    d: "M 1151.5,1035.5 C 1148.47,1035.87 1145.8,1035.2 1143.5,1033.5C 1148.22,1032.81 1152.89,1031.48 1157.5,1029.5C 1159.85,1027.75 1160.85,1025.42 1160.5,1022.5C 1145.94,1023.45 1139.44,1016.78 1141,1002.5C 1142.89,998.942 1145.73,996.442 1149.5,995C 1154.74,993.661 1160.07,993.161 1165.5,993.5C 1165.67,1004.17 1165.5,1014.84 1165,1025.5C 1162.62,1031.72 1158.12,1035.05 1151.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 1292.5,1006.5 C 1285.5,1006.5 1278.5,1006.5 1271.5,1006.5C 1271.23,1008.1 1271.57,1009.43 1272.5,1010.5C 1273.69,1015.19 1276.69,1018.02 1281.5,1019C 1284.48,1019.5 1287.48,1019.66 1290.5,1019.5C 1290.5,1020.5 1290.5,1021.5 1290.5,1022.5C 1272.67,1024.51 1265.5,1016.84 1269,999.5C 1277.23,990.016 1284.9,990.35 1292,1000.5C 1292.5,1002.47 1292.66,1004.47 1292.5,1006.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 1394.5,1002.5 C 1394.5,1003.83 1394.5,1005.17 1394.5,1006.5C 1387.65,1006.18 1380.98,1006.51 1374.5,1007.5C 1374.44,1014.17 1377.77,1018 1384.5,1019C 1387.15,1019.5 1389.81,1019.66 1392.5,1019.5C 1392.5,1020.5 1392.5,1021.5 1392.5,1022.5C 1373.75,1024.27 1366.92,1016.27 1372,998.5C 1377.18,992.108 1383.35,990.942 1390.5,995C 1392.54,997.185 1393.87,999.685 1394.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a4a",
    d: "M 1419.5,992.5 C 1424,992.005 1427.83,993.338 1431,996.5C 1435.74,992.69 1440.91,991.856 1446.5,994C 1447.7,994.903 1448.53,996.069 1449,997.5C 1449.5,1005.83 1449.67,1014.16 1449.5,1022.5C 1448.17,1022.5 1446.83,1022.5 1445.5,1022.5C 1445.67,1014.83 1445.5,1007.16 1445,999.5C 1440.98,995.782 1436.82,995.782 1432.5,999.5C 1431.5,1007.14 1431.17,1014.8 1431.5,1022.5C 1429.83,1022.5 1428.17,1022.5 1426.5,1022.5C 1426.67,1014.83 1426.5,1007.16 1426,999.5C 1425.1,997.632 1423.6,996.632 1421.5,996.5C 1418.48,997.429 1415.64,998.762 1413,1000.5C 1412.5,1007.83 1412.33,1015.16 1412.5,1022.5C 1411.17,1022.5 1409.83,1022.5 1408.5,1022.5C 1408.5,1012.83 1408.5,1003.17 1408.5,993.5C 1409.83,993.5 1411.17,993.5 1412.5,993.5C 1412.28,994.675 1412.61,995.675 1413.5,996.5C 1415.57,995.143 1417.57,993.81 1419.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c9c9",
    d: "M 1481.5,987.5 C 1486.17,987.5 1490.83,987.5 1495.5,987.5C 1495.5,999.167 1495.5,1010.83 1495.5,1022.5C 1494.51,1011.35 1494.17,1000.01 1494.5,988.5C 1489.97,988.818 1485.63,988.485 1481.5,987.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454545",
    d: "M 1540.5,992.5 C 1541.45,993.919 1541.78,995.585 1541.5,997.5C 1537.56,998.035 1533.9,999.368 1530.5,1001.5C 1529.5,1008.47 1529.17,1015.47 1529.5,1022.5C 1528.17,1022.5 1526.83,1022.5 1525.5,1022.5C 1525.5,1012.83 1525.5,1003.17 1525.5,993.5C 1526.83,993.5 1528.17,993.5 1529.5,993.5C 1529.24,994.978 1529.57,996.311 1530.5,997.5C 1533.94,995.814 1537.27,994.147 1540.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 1554.5,993.5 C 1560.07,992.99 1565.41,993.823 1570.5,996C 1571.21,997.255 1572.04,998.421 1573,999.5C 1573.5,1007.49 1573.67,1015.49 1573.5,1023.5C 1566.94,1024.08 1560.61,1023.25 1554.5,1021C 1548.22,1013.51 1549.89,1008.17 1559.5,1005C 1562.82,1004.5 1566.15,1004.33 1569.5,1004.5C 1569.56,1001.44 1568.22,999.272 1565.5,998C 1561.85,997.501 1558.18,997.335 1554.5,997.5C 1554.5,996.167 1554.5,994.833 1554.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 1635.5,992.5 C 1645.48,992.481 1650.48,997.481 1650.5,1007.5C 1643.5,1007.5 1636.5,1007.5 1629.5,1007.5C 1630.01,1013.19 1633.01,1017.02 1638.5,1019C 1641.82,1019.5 1645.15,1019.67 1648.5,1019.5C 1648.5,1020.5 1648.5,1021.5 1648.5,1022.5C 1631.96,1024.79 1624.46,1017.79 1626,1001.5C 1627.87,997.006 1631.04,994.006 1635.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 1691.5,992.5 C 1706.77,993.021 1712.27,1000.69 1708,1015.5C 1702.02,1024.24 1694.52,1025.74 1685.5,1020C 1678.53,1008.69 1680.53,999.528 1691.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 1806.5,993.5 C 1807.83,993.5 1809.17,993.5 1810.5,993.5C 1810.24,994.978 1810.57,996.311 1811.5,997.5C 1814.89,995.301 1818.56,993.968 1822.5,993.5C 1822.5,994.833 1822.5,996.167 1822.5,997.5C 1818.43,998.114 1814.6,999.448 1811,1001.5C 1810.5,1008.49 1810.33,1015.49 1810.5,1022.5C 1809.17,1022.5 1807.83,1022.5 1806.5,1022.5C 1806.5,1012.83 1806.5,1003.17 1806.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#454545",
    d: "M 1838.5,993.5 C 1838.5,1003.17 1838.5,1012.83 1838.5,1022.5C 1837.17,1022.5 1835.83,1022.5 1834.5,1022.5C 1834.5,1012.83 1834.5,1003.17 1834.5,993.5C 1835.83,993.5 1837.17,993.5 1838.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4e4e4e",
    d: "M 1914.5,993.5 C 1918.51,993.334 1922.51,993.501 1926.5,994C 1928.62,995.122 1930.46,996.622 1932,998.5C 1933.44,1006.72 1933.94,1015.06 1933.5,1023.5C 1928.49,1023.67 1923.49,1023.5 1918.5,1023C 1910.1,1020.15 1908.43,1015.15 1913.5,1008C 1918.08,1005.23 1923.08,1003.73 1928.5,1003.5C 1928.2,999.871 1926.2,997.871 1922.5,997.5C 1920.05,996.527 1917.39,996.194 1914.5,996.5C 1914.5,995.5 1914.5,994.5 1914.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c4c4c",
    d: "M 1961.5,992.5 C 1967.06,991.231 1970.89,993.231 1973,998.5C 1973.5,1006.49 1973.67,1014.49 1973.5,1022.5C 1971.83,1022.5 1970.17,1022.5 1968.5,1022.5C 1968.67,1014.83 1968.5,1007.16 1968,999.5C 1967.42,997.148 1965.92,996.148 1963.5,996.5C 1960.05,997.141 1956.88,998.474 1954,1000.5C 1953.5,1007.83 1953.33,1015.16 1953.5,1022.5C 1952.17,1022.5 1950.83,1022.5 1949.5,1022.5C 1949.5,1012.83 1949.5,1003.17 1949.5,993.5C 1950.83,993.5 1952.17,993.5 1953.5,993.5C 1953.28,994.675 1953.61,995.675 1954.5,996.5C 1957.06,995.392 1959.39,994.059 1961.5,992.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 2008.5,993.5 C 2010.69,993.511 2011.52,994.511 2011,996.5C 2007.32,1000.02 2003.82,1003.68 2000.5,1007.5C 2004.98,1012.49 2009.65,1017.32 2014.5,1022C 2013.65,1023.02 2012.65,1023.86 2011.5,1024.5C 2005.68,1019.18 2000.01,1013.68 1994.5,1008C 1999.37,1003.3 2004.04,998.465 2008.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a4a",
    d: "M 2026.5,993.5 C 2030.18,993.335 2033.85,993.501 2037.5,994C 2040.03,994.516 2042.2,995.683 2044,997.5C 2045.44,1006.06 2045.94,1014.72 2045.5,1023.5C 2040.82,1023.67 2036.15,1023.5 2031.5,1023C 2022.86,1020.58 2020.86,1015.75 2025.5,1008.5C 2029.65,1005.51 2034.32,1004.01 2039.5,1004C 2042.15,1001.27 2041.49,999.274 2037.5,998C 2033.94,996.763 2030.27,996.263 2026.5,996.5C 2026.5,995.5 2026.5,994.5 2026.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1b1",
    d: "M 1495.5,1022.5 C 1496.83,1022.5 1498.17,1022.5 1499.5,1022.5C 1499.5,1010.83 1499.5,999.167 1499.5,987.5C 1504.17,987.5 1508.83,987.5 1513.5,987.5C 1513.5,986.5 1513.5,985.5 1513.5,984.5C 1502.83,984.5 1492.17,984.5 1481.5,984.5C 1481.5,985.5 1481.5,986.5 1481.5,987.5C 1480.57,986.432 1480.23,985.099 1480.5,983.5C 1491.83,983.5 1503.17,983.5 1514.5,983.5C 1514.5,985.167 1514.5,986.833 1514.5,988.5C 1509.83,988.5 1505.17,988.5 1500.5,988.5C 1500.5,1000.17 1500.5,1011.83 1500.5,1023.5C 1498.59,1023.78 1496.92,1023.45 1495.5,1022.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 910.5,996.5 C 921.887,996.555 926.054,1002.22 923,1013.5C 920.646,1019.09 916.479,1020.93 910.5,1019C 905.206,1015.56 903.373,1010.73 905,1004.5C 906.273,1001.4 908.107,998.736 910.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 999.5,1001.5 C 994.944,1003.44 989.944,1004.11 984.5,1003.5C 986.006,996.954 990.006,994.787 996.5,997C 998.141,998.129 999.141,999.629 999.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 1035.5,1002.5 C 1030.5,1003.83 1025.5,1003.83 1020.5,1002.5C 1023.08,996.421 1027.41,994.921 1033.5,998C 1034.58,999.33 1035.25,1000.83 1035.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 1287.5,1001.5 C 1282.94,1003.44 1277.94,1004.11 1272.5,1003.5C 1274.01,996.954 1278.01,994.787 1284.5,997C 1286.14,998.129 1287.14,999.629 1287.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 1379.5,996.5 C 1385.57,995.262 1389.24,997.595 1390.5,1003.5C 1385.13,1003.83 1379.79,1003.49 1374.5,1002.5C 1375.5,999.845 1377.16,997.845 1379.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 1645.5,1002.5 C 1640.5,1003.83 1635.5,1003.83 1630.5,1002.5C 1633.08,996.421 1637.41,994.921 1643.5,998C 1644.58,999.33 1645.25,1000.83 1645.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 1691.5,996.5 C 1702.89,996.555 1707.05,1002.22 1704,1013.5C 1701.65,1019.09 1697.48,1020.93 1691.5,1019C 1683.59,1011.62 1683.59,1004.12 1691.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9f9f9f",
    d: "M 1914.5,993.5 C 1914.5,994.5 1914.5,995.5 1914.5,996.5C 1917.39,996.194 1920.05,996.527 1922.5,997.5C 1919.5,997.5 1916.5,997.5 1913.5,997.5C 1913.23,995.901 1913.57,994.568 1914.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 1151.5,997.5 C 1154.5,997.5 1157.5,997.5 1160.5,997.5C 1160.5,1004.5 1160.5,1011.5 1160.5,1018.5C 1151.81,1019.45 1146.48,1015.78 1144.5,1007.5C 1145.3,1003.04 1147.64,999.707 1151.5,997.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f8f8",
    d: "M 1600.5,997.5 C 1602.83,997.5 1605.17,997.5 1607.5,997.5C 1607.5,1004.83 1607.5,1012.17 1607.5,1019.5C 1593.26,1019.8 1588.92,1013.64 1594.5,1001C 1596.43,999.541 1598.43,998.375 1600.5,997.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 1719.5,996.5 C 1721.5,996.5 1723.5,996.5 1725.5,996.5C 1725.5,1005.17 1725.5,1013.83 1725.5,1022.5C 1724.51,1014.35 1724.17,1006.02 1724.5,997.5C 1722.59,997.784 1720.92,997.451 1719.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bababa",
    d: "M 942.5,993.5 C 942.5,1003.17 942.5,1012.83 942.5,1022.5C 943.833,1022.5 945.167,1022.5 946.5,1022.5C 945.081,1023.45 943.415,1023.78 941.5,1023.5C 941.173,1013.32 941.506,1003.32 942.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a2",
    d: "M 882.5,993.5 C 882.5,1003.17 882.5,1012.83 882.5,1022.5C 883.833,1022.5 885.167,1022.5 886.5,1022.5C 885.081,1023.45 883.415,1023.78 881.5,1023.5C 881.173,1013.32 881.506,1003.32 882.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3a3",
    d: "M 1838.5,993.5 C 1839.49,1003.32 1839.83,1013.32 1839.5,1023.5C 1837.59,1023.78 1835.92,1023.45 1834.5,1022.5C 1835.83,1022.5 1837.17,1022.5 1838.5,1022.5C 1838.5,1012.83 1838.5,1003.17 1838.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bababa",
    d: "M 1217.5,996.5 C 1214.38,997.479 1211.04,997.813 1207.5,997.5C 1207.5,1002.83 1207.5,1008.17 1207.5,1013.5C 1206.51,1008.02 1206.18,1002.36 1206.5,996.5C 1210.17,996.5 1213.83,996.5 1217.5,996.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaeae",
    d: "M 1103.5,993.5 C 1103.5,1003.17 1103.5,1012.83 1103.5,1022.5C 1104.83,1022.5 1106.17,1022.5 1107.5,1022.5C 1106.08,1023.45 1104.41,1023.78 1102.5,1023.5C 1102.17,1013.32 1102.51,1003.32 1103.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838383",
    d: "M 999.5,1001.5 C 1000.4,1002.21 1000.74,1003.21 1000.5,1004.5C 994.974,1004.82 989.64,1004.49 984.5,1003.5C 989.944,1004.11 994.944,1003.44 999.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7e",
    d: "M 1020.5,1002.5 C 1025.5,1003.83 1030.5,1003.83 1035.5,1002.5C 1036.04,1002.56 1036.38,1002.89 1036.5,1003.5C 1030.83,1004.83 1025.17,1004.83 1019.5,1003.5C 1019.62,1002.89 1019.96,1002.56 1020.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838383",
    d: "M 1287.5,1001.5 C 1288.4,1002.21 1288.74,1003.21 1288.5,1004.5C 1282.97,1004.82 1277.64,1004.49 1272.5,1003.5C 1277.94,1004.11 1282.94,1003.44 1287.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7e",
    d: "M 1630.5,1002.5 C 1635.5,1003.83 1640.5,1003.83 1645.5,1002.5C 1646.04,1002.56 1646.38,1002.89 1646.5,1003.5C 1640.83,1004.83 1635.17,1004.83 1629.5,1003.5C 1629.62,1002.89 1629.96,1002.56 1630.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a2",
    d: "M 1806.5,993.5 C 1806.5,1003.17 1806.5,1012.83 1806.5,1022.5C 1807.83,1022.5 1809.17,1022.5 1810.5,1022.5C 1809.08,1023.45 1807.41,1023.78 1805.5,1023.5C 1805.17,1013.32 1805.51,1003.32 1806.5,993.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858585",
    d: "M 1351.5,1003.5 C 1352.92,1002.55 1354.59,1002.22 1356.5,1002.5C 1356.5,1009.5 1356.5,1016.5 1356.5,1023.5C 1351.97,1023.82 1347.63,1023.48 1343.5,1022.5C 1347.5,1022.5 1351.5,1022.5 1355.5,1022.5C 1355.5,1016.17 1355.5,1009.83 1355.5,1003.5C 1354.17,1003.5 1352.83,1003.5 1351.5,1003.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 1004.5,1006.5 C 998.021,1007.49 991.354,1007.82 984.5,1007.5C 984.5,1008.5 984.5,1009.5 984.5,1010.5C 983.566,1009.43 983.232,1008.1 983.5,1006.5C 990.5,1006.5 997.5,1006.5 1004.5,1006.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 1292.5,1006.5 C 1286.02,1007.49 1279.35,1007.82 1272.5,1007.5C 1272.5,1008.5 1272.5,1009.5 1272.5,1010.5C 1271.57,1009.43 1271.23,1008.1 1271.5,1006.5C 1278.5,1006.5 1285.5,1006.5 1292.5,1006.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 1394.5,1002.5 C 1395.45,1003.92 1395.78,1005.59 1395.5,1007.5C 1388.5,1007.5 1381.5,1007.5 1374.5,1007.5C 1380.98,1006.51 1387.65,1006.18 1394.5,1006.5C 1394.5,1005.17 1394.5,1003.83 1394.5,1002.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a5a5",
    d: "M 1126.5,998.5 C 1127.49,1006.65 1127.83,1014.98 1127.5,1023.5C 1125.59,1023.78 1123.92,1023.45 1122.5,1022.5C 1123.83,1022.5 1125.17,1022.5 1126.5,1022.5C 1126.5,1014.5 1126.5,1006.5 1126.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 1253.5,998.5 C 1254.49,1006.65 1254.83,1014.98 1254.5,1023.5C 1252.59,1023.78 1250.92,1023.45 1249.5,1022.5C 1250.83,1022.5 1252.17,1022.5 1253.5,1022.5C 1253.5,1014.5 1253.5,1006.5 1253.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 1562.5,1007.5 C 1564.83,1007.5 1567.17,1007.5 1569.5,1007.5C 1569.5,1011.5 1569.5,1015.5 1569.5,1019.5C 1565.82,1019.67 1562.15,1019.5 1558.5,1019C 1555.79,1017.14 1554.96,1014.64 1556,1011.5C 1558.01,1009.75 1560.18,1008.42 1562.5,1007.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 1921.5,1007.5 C 1923.83,1007.5 1926.17,1007.5 1928.5,1007.5C 1928.5,1011.5 1928.5,1015.5 1928.5,1019.5C 1924.09,1019.98 1919.92,1019.31 1916,1017.5C 1914.81,1015.96 1914.48,1014.29 1915,1012.5C 1916.8,1010.17 1918.97,1008.51 1921.5,1007.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 2034.5,1007.5 C 2036.83,1007.5 2039.17,1007.5 2041.5,1007.5C 2041.5,1011.5 2041.5,1015.5 2041.5,1019.5C 2037.82,1019.67 2034.15,1019.5 2030.5,1019C 2027.79,1017.14 2026.96,1014.64 2028,1011.5C 2030.01,1009.75 2032.18,1008.42 2034.5,1007.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6c6c6",
    d: "M 1881.5,984.5 C 1880.17,984.5 1878.83,984.5 1877.5,984.5C 1877.5,997.167 1877.5,1009.83 1877.5,1022.5C 1885.17,1022.5 1892.83,1022.5 1900.5,1022.5C 1900.5,1021.17 1900.5,1019.83 1900.5,1018.5C 1901.45,1019.92 1901.78,1021.59 1901.5,1023.5C 1893.17,1023.5 1884.83,1023.5 1876.5,1023.5C 1876.5,1010.17 1876.5,996.833 1876.5,983.5C 1878.41,983.216 1880.08,983.549 1881.5,984.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 965.5,998.5 C 966.493,1006.65 966.826,1014.98 966.5,1023.5C 964.585,1023.78 962.919,1023.45 961.5,1022.5C 962.833,1022.5 964.167,1022.5 965.5,1022.5C 965.5,1014.5 965.5,1006.5 965.5,998.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababab",
    d: "M 1058.5,1001.5 C 1058.5,1008.83 1058.5,1016.17 1058.5,1023.5C 1056.59,1023.78 1054.92,1023.45 1053.5,1022.5C 1054.83,1022.5 1056.17,1022.5 1057.5,1022.5C 1057.18,1015.31 1057.51,1008.31 1058.5,1001.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a5a5",
    d: "M 1028.5,1018.5 C 1031.83,1018.5 1035.17,1018.5 1038.5,1018.5C 1038.77,1020.1 1038.43,1021.43 1037.5,1022.5C 1037.5,1021.5 1037.5,1020.5 1037.5,1019.5C 1034.29,1019.81 1031.29,1019.48 1028.5,1018.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a0a0",
    d: "M 1143.5,1033.5 C 1145.8,1035.2 1148.47,1035.87 1151.5,1035.5C 1149.05,1036.47 1146.39,1036.81 1143.5,1036.5C 1143.5,1035.5 1143.5,1034.5 1143.5,1033.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgjta1);
export default __webpack_public_path__ + "static/media/CGJTA-1.3bcce0abc68a48f148382fb77f9b3731.svg";
export { ForwardRef as ReactComponent };